import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=0ab1e00d&scoped=true&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&id=0ab1e00d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab1e00d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/PMS_Client/PMS_Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0ab1e00d')) {
      api.createRecord('0ab1e00d', component.options)
    } else {
      api.reload('0ab1e00d', component.options)
    }
    module.hot.accept("./Modal.vue?vue&type=template&id=0ab1e00d&scoped=true&", function () {
      api.rerender('0ab1e00d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/controls/Modal.vue"
export default component.exports